import { getTranslation, Lang } from "@/data/translation";
import { PortfolioHoldingsData } from "@/services/13f/portfolio-distribution";
import { ChartData } from "chart.js";
import uniq from "lodash/uniq";

const industryColors = [
  "#58C1D7CC",
  "#2D80AFCC",
  "#003D70CC",
  "#4947BE80",
  "#4947BECC",
  "#159A5B80",
  "#159A5BCC",
  "#FDB62BCC",
  "#F67F13CC",
  "#EA433580",
  "#EA4335CC",
];

export const getIndustrialDistributionColorsMap = ({
  noStockLabel,
  rawData,
}: {
  noStockLabel: string;
  rawData: { label: string }[];
}) => {
  if (!rawData.length) return new Map<string, string>();

  const labels = uniq(rawData.map(({ label }) => label));

  const result = new Map<string, string>();
  for (const [index, label] of labels.entries()) {
    result.set(label, industryColors[index]);
  }

  result.set(noStockLabel, "#DEDEDE");

  return result;
};

export const extractIndustrialDistributionData = ({
  lang,
  data,
}: {
  lang: Lang;
  data: PortfolioHoldingsData<"industrial-distribution">[];
}): ChartData<"bar"> => {
  const { t } = getTranslation({ lang });
  const colorsMap = getIndustrialDistributionColorsMap({
    noStockLabel: t.chip.noStock,
    rawData: data.map((item) => ({ label: item.sectorCategory })),
  });
  const labels = [...new Set(data.map((item) => item.quarter))];
  const industry = [...new Set(data.map((item) => item.sectorCategory))];
  const datasets = industry.map((industry) => ({
    label: industry || "",
    backgroundColor: colorsMap.get(industry) ?? "",
    borderColor: colorsMap.get(industry) ?? "",
    data: labels.map((quarter) => {
      const dataPoint = data.find(
        (item) => item.quarter === quarter && item.sectorCategory === industry
      );
      return dataPoint?.proportion ? dataPoint.proportion * 0.01 : 0;
    }),
  }));

  return {
    labels,
    datasets,
  };
};
